import type { ReactNode } from "react";
import { Typography } from "@mui/material";
import { PivotTab } from "design-components";
import { useNavigate } from "react-router-dom";

export type SettingsTabId = "users" | "bookings" | "roles";

interface SettingsPageShellProps {
  activeTab: SettingsTabId;
  children: ReactNode;
}

export const SettingsPageShell = ({
  activeTab,
  children,
}: SettingsPageShellProps) => {
  const navigate = useNavigate();

  return (
    <div className="settings-page-shell">
      <div className="settings-page-shell__title-wrap">
        <Typography variant="h5" className="settings-page-shell__title">
          Settings
        </Typography>
      </div>
      <div className="settings-page-shell__tabs">
        <PivotTab
          className="settings-page-shell__pivot-tab"
          label="Users"
          active={activeTab === "users"}
          onActivate={() => navigate("/settings/users")}
        />
        <PivotTab
          className="settings-page-shell__pivot-tab"
          label="Bookings"
          active={activeTab === "bookings"}
          onActivate={() => navigate("/settings/bookings")}
        />
      </div>
      {children}
    </div>
  );
};
